module.exports = __webpack_public_path__ + "media/svg/back-26f4583f.svg";